<template>
  <button
    class="btn pmd-btn-fab btn-fab pmd-ripple-effect btn-dark"
    type="button"
    v-if="fab"
    @click="toTop"
  >
    <i class="fa fa-arrow-up"></i>
  </button>
</template>

<script>
export default {
  data: () => ({
    fab: false
  }),
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      if (typeof window === "undefined") return;

      const top = window.pageYOffset || document.documentElement.offsetTop || 0;

      this.fab = top > 300;
    },
    toTop() {
      window.scrollTo(0,0);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-fab { 
  position: fixed; 
  bottom: 15px; 
  right: 15px;
  border-radius: 100%;
  z-index: 999;
}
</style>
